if (!customElements.get('jm-blog-news')) {
  customElements.define('jm-blog-news', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const track = this.querySelector('.jm-news__track');
      const buttons = [...this.querySelectorAll('[data-direction]')];
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        buttons.forEach(button => {
          button.disabled = max < 2 || (Number(button.dataset.direction) < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2);
        });
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = track.firstElementChild;
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        track.scrollBy({ left: step * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options));
      track.addEventListener('scroll', update, { ...options, passive: true });
      this.resize?.disconnect();
      this.resize = new ResizeObserver(update);
      this.resize.observe(track);
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}
